export type TableSubTotalsSettings = {
    enabled: boolean;
};
